/**
 * The canvas's "changed" marker (PRD-0075 R-C2): a small dot on a node merged, or with a property
 * changed, in the last 30 days. Placed off-screen; `useNodeCornerAnchors` pins it to the node's
 * top-left corner on every render of the graph.
 */
import type { Ref } from 'react'
import { useTranslation } from 'react-i18next'

export function ChangedNodeMarker({ ref }: { ref: Ref<HTMLSpanElement> }) {
  const { t } = useTranslation()
  return (
    <span
      ref={ref}
      role="img"
      aria-label={t('investigations.entityDetail.history.changed')}
      title={t('investigations.entityDetail.history.changedHint')}
      // z-10: above the canvas, below the notes panel, like the "+N" chips; never takes a click.
      className="pointer-events-none absolute z-10 size-2.5 rounded-full bg-info ring-2 ring-background will-change-transform"
      style={{ left: -9999, top: -9999, transform: 'translate(-50%, -50%)' }}
    />
  )
}
